import { HttpClient } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';

import { authInterceptor } from '@rent2end/core/auth';

import { apiClientFactory } from './api-client.factory';
import { WEB_APP_API_BASE_URL } from './web-app-api-base-url.token';
import { languageInterceptor } from '@rent2end/core/translation';

export const WEB_APP_API_CLIENT = new InjectionToken<HttpClient>(
  'Web App API Client',
  {
    factory: () => apiClientFactory(inject(WEB_APP_API_BASE_URL), [authInterceptor, languageInterceptor])(),
    providedIn: 'root',
  },
);
